import { Icon } from '@chakra-ui/react';

export const Shorten = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M12.0099 15.0498C11.7977 15.0498 11.5943 15.1375 11.4443 15.2934L8.24432 18.6199L8.24432 18.6201C8.0899 18.775 8.00191 18.9879 8.00003 19.2109C7.99816 19.434 8.08267 19.6485 8.23427 19.8063C8.38602 19.964 8.59239 20.0517 8.80695 20.0498C9.02151 20.0478 9.22641 19.9564 9.37548 19.796L12.5755 16.4695L12.5755 16.4693C12.7255 16.3134 12.8097 16.1019 12.8097 15.8814C12.8097 15.6609 12.7255 15.4494 12.5755 15.2934C12.4255 15.1375 12.222 15.0498 12.0099 15.0498L12.0099 15.0498Z"
      fill="currentColor"
    />
    <path
      d="M12.0098 15.0497C11.7976 15.0497 11.5942 15.1374 11.4442 15.2933C11.2942 15.4493 11.21 15.6608 11.21 15.8813C11.21 16.1018 11.2942 16.3133 11.4442 16.4692L14.6442 19.7957C14.8474 19.9997 15.1391 20.0774 15.4115 19.9997C15.684 19.922 15.8968 19.7008 15.9716 19.4176C16.0462 19.1343 15.9717 18.8312 15.7754 18.62L12.5754 15.2935C12.4254 15.1375 12.2219 15.0497 12.0098 15.0497Z"
      fill="currentColor"
    />
    <rect
      width="1.6"
      height="8"
      rx="0.8"
      transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 16 14.5498)"
      fill="currentColor"
    />
    <path
      d="M11.9901 7.95019C12.2023 7.95019 12.4057 7.86248 12.5557 7.70655L15.7557 4.38006L15.7557 4.37992C15.9101 4.22496 15.9981 4.0121 16 3.78905C16.0018 3.56601 15.9173 3.35148 15.7657 3.19373C15.614 3.03599 15.4076 2.94828 15.193 2.95023C14.9785 2.95218 14.7736 3.04365 14.6245 3.20403L11.4245 6.53053L11.4245 6.53067C11.2745 6.6866 11.1903 6.8981 11.1903 7.11861C11.1903 7.33913 11.2745 7.55062 11.4245 7.70655C11.5745 7.86249 11.778 7.9502 11.9901 7.9502L11.9901 7.95019Z"
      fill="currentColor"
    />
    <path
      d="M11.9902 7.95032C12.2024 7.95032 12.4058 7.86261 12.5558 7.70667C12.7058 7.55074 12.79 7.33925 12.79 7.11873C12.79 6.89822 12.7058 6.68672 12.5558 6.53079L9.35581 3.20429C9.15264 3.00033 8.86092 2.92264 8.58852 3.00033C8.31597 3.07802 8.10317 3.29924 8.02842 3.58243C7.95382 3.86575 8.02829 4.16884 8.22463 4.38005L11.4246 7.70654C11.5746 7.86247 11.7781 7.95032 11.9902 7.95032Z"
      fill="currentColor"
    />
    <rect
      width="1.6"
      height="8"
      rx="0.8"
      transform="matrix(1.19249e-08 1 1 -1.19249e-08 8 8.4502)"
      fill="currentColor"
    />
  </Icon>
);
